import "./AgricultureSuccessCase.module.css";
import Header from "@/reusable_sections/Header";
import Agriculturehero from "./sections/Agriculturehero";
import Solutions from "./sections/Solutions";
import EfficiencyMetrics from "./sections/EfficiencyMetrics";
import Sustainability from "./sections/Sustainability";
import Footer from "@/reusable_sections/Footer";
export default function AgricultureSuccessCasePage() {
  return <div>
      <Header />
      <Agriculturehero />
      <Solutions />
      <EfficiencyMetrics />
      <Sustainability />
      <Footer />
    </div>;
}